import React from 'react';

export interface IUser {
  isGuest: boolean,
  formKey: string,
  email: string,
  name: string,
  groupId: string,
  isPro: boolean,
  id: string,
  isLoyal: boolean,
  rewardPoints: number,
  firstName: string,
  mobile: string,
  showEmail?: boolean,
}
const userContext = React.createContext({
  userData: {} as IUser
});

const { Provider, Consumer } = userContext;

export const UserContextProvider = Provider;

export const UserContextConsumer = Consumer;

export const UserContext = userContext;
